module.exports = __webpack_public_path__ + "assets/media/letter-about.7f64daaa.svg";